/* eslint-disable no-warning-comments */
/* eslint-disable react-hooks/rules-of-hooks */

import './src/styles/globals.scss'

import Lenis from '@studio-freight/lenis'
import classNames from 'classnames'
import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import React, {useState} from 'react'

import {loadScripts} from '@/common/scripts'
import {Loader} from '@/components2025/Loader'

export const onInitialClientRender = () => {
  window.scrollTo(0, 0)
}

export const onRouteUpdate = () => {
  window.lenis?.scrollTo(0, {immediate: true, force: true})
}

export const wrapPageElement = ({element}) => {
  React.useEffect(() => {
    ScrollTrigger.config({
      ignoreMobileResize: true,
    })
  }, [])

  React.useEffect(() => {
    const lenis = new Lenis()

    lenis.on('scroll', () => {
      ScrollTrigger.update()
    })

    function onWheel(event) {
      const paths = event.composedPath()

      paths.forEach((el) => {
        if (el instanceof HTMLElement && el?.getAttribute('id') === 'headlessui-portal-root') {
          event.stopPropagation()
        }
      })
    }

    lenis.options.content.addEventListener('wheel', onWheel)

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000)
    })

    gsap.ticker.lagSmoothing(0)

    // Prevent scrolling on load
    // Re-enable after loader complete
    lenis.stop()

    window.lenis = lenis

    return () => {
      lenis.options.content.removeEventListener('wheel', onWheel)
    }
  }, [])

  React.useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera
    if (/windows phone/i.test(userAgent)) {
      document.documentElement.classList.add('windows')
    } else if (/android/i.test(userAgent)) {
      document.documentElement.classList.add('android')
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      document.documentElement.classList.add('ios')
    }
  }, [])

  React.useEffect(() => {
    loadScripts()
    window.lenis?.start()
  }, [])

  const [showLoader, setShowLoader] = useState(false)

  return (
    <div className={classNames({'has-loader': showLoader})} id='rootLoading'>
      {showLoader && (
        <Loader
          onComplete={() => {
            setShowLoader(false)
            window.lenis?.start()
          }}
        />
      )}
      {element}
    </div>
  )
}
